import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import JSZip from 'jszip';
import ParamForm from './ParamForm.vue';
import FileItem from './FileItem.vue';
import { checkImageUrl, showErrorMessage, getFileInfoByPath, downloadSingle, downloadBatch } from '@/utils/index';
import { processURL, getImageAll, webdownloadimgallAPI } from '@/api/index';
import { ElLoading } from 'element-plus';
export default {
  name: 'Url',
  components: {
    FileItem,
    ParamForm
  },
  data() {
    return {
      placeholder: '请输入在线网页链接，点击获取按钮获取网页图片，即可下载网页内所有图片',
      text: '',
      radioA: '1',
      options: {
        quality: 75,
        format: '',
        cdn: false,
        cdnDir: ''
      },
      imgAllList: [],
      fileList: [],
      showClear: false,
      promises: [],
      zip: null,
      isMobile: false
    };
  },
  watch: {
    radioA(newv) {
      if (newv === '1') {
        this.placeholder = '请输入在线网页链接，点击获取按钮获取网页图片，即可下载网页内所有图片';
      } else if (newv === '2') {
        this.placeholder = '请输入在线图片链接，支持多个链接批量处理，以逗号或者换行分隔';
      }
    }
  },
  computed: {
    uploadOptions() {
      const {
        quality,
        format,
        cdn,
        cdnDir
      } = this.options;
      return {
        quality: quality,
        format: format,
        cdn: cdn || '',
        cdnDir
      };
    },
    disabledBtn() {
      return this.imgAllList.length === 0;
    }
  },
  mounted() {
    // 检测设备类型
    this.checkDeviceType();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkDeviceType);
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener('resize', this.checkDeviceType);
  },
  methods: {
    // 检测设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },
    onInputBlur() {
      if (!this.text) {
        showErrorMessage('链接地址不能为空');
        return;
      }
      if (!this.text.startsWith('http')) {
        showErrorMessage('请输入有效的链接地址');
        return;
      }
      const loadingss = ElLoading.service({
        lock: true,
        text: '图片加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const time = Date.now();
      const inputText = this.text;
      let list = inputText.split(/[\n|,|，]/).map(item => {
        // 去掉协议以及双斜杠，以便去重
        const urlInt = item.replace('http:', '').replace('https:', '').replace('//', '');
        const urlSplit = urlInt.split('?');
        let url = urlSplit[0];
        const url2 = url.split('@');
        if (url2.length > 0) {
          url = url2[0];
        }
        return url;
      });
      if (this.radioA === '1') {
        getImageAll({
          url: this.text
        }).then(res => {
          if (res.data && res.data.status) {
            if (res.data.data && res.data.data.length > 0) {
              let list = res.data.data.filter(item => item !== '');
              list.map(i => {
                let u = i.split('@');
                if (u && u[0]) {
                  return u[0];
                } else {
                  return i;
                }
              });
              this.imgAllList = list;
              this.showClear = true;
              loadingss.close();
            } else {
              loadingss.close();
              showErrorMessage(res.data.message || '获取图片失败');
            }
          } else {
            loadingss.close();
            showErrorMessage(res.data.message || '获取图片失败');
          }
        }).catch(() => {
          loadingss.close();
        });
      } else {
        list = Array.from(new Set(list)).filter(item => checkImageUrl(item)).filter(item => !this.fileList.find(i => i.url === item)).map(item => {
          return {
            time,
            url: item,
            name: getFileInfoByPath(item).name,
            process: 'uploading',
            uid: `${time}-${item}`
          };
        });
        if (list.length) {
          this.fileList = [...this.fileList, ...list];
          list.map(item => {
            processURL({
              ...this.uploadOptions,
              url: item.url
            }, {
              'x-uid': item.uid
            }).then(res => {
              const uid = res.headers['x-uid'];
              const file = this.fileList.find(item => item.uid === uid);
              if (res?.status === 200 && res?.data?.status === 1) {
                if (file) {
                  file.size = res.data.data.originSize;
                  file.status = 'success';
                  file.response = res.data;
                  this.fileList = [...this.fileList];
                }
                loadingss.close();
              } else {
                if (file) {
                  file.status = 'fail';
                  this.fileList = [...this.fileList];
                }
                loadingss.close();
              }
            }).catch(err => {
              const message = err?.message ?? '操作失败!';
              showErrorMessage(message);
              loadingss.close();
            });
          });
        } else {
          showErrorMessage('请输入有效的图片链接');
          loadingss.close();
        }
      }
      this.text = '';
    },
    downloadAll() {
      const list = [];
      for (let idx = 0; idx < this.fileList.length; idx++) {
        const item = this.fileList[idx];
        if (item?.response?.data?.images) {
          list.push(item.response.data.images[0]);
        }
      }
      if (list.length) {
        downloadBatch(list);
      }
    },
    clearFn() {
      this.text = '';
      this.imgAllList = [];
      this.showClear = false;
    },
    downloadFn(item) {
      const time = Date.now();
      downloadSingle({
        src: item,
        name: `${time}.download.png`
      });
    },
    downloadAllimg() {
      downloadBatch(this.imgAllList);
    },
    // base64 转 png
    async savaBase64AsPng(base64Data) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.src = base64Data;
        const time = Date.now();
        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var context = canvas.getContext("2d");
          context.drawImage(img, 0, 0);
          canvas.toBlob(blob => {
            const file = new File([blob], `${time}_base64.png`, {
              type: "image/png"
            });
            resolve(file);
          }, "image/png");
        };
        img.onerror = error => {
          reject(error);
        };
      });
    },
    // 下载 zip 文件
    async downLoadZipAllImg() {
      const that = this;
      this.zip = new JSZip();
      const imgList = [];
      const base64List = [];
      this.imgAllList.forEach(item => {
        if (item.includes(';base64')) {
          base64List.push(item);
        } else if (item === '') {
          console.log(item, '66');
        } else {
          imgList.push(item);
        }
      });

      // 请求接口
      webdownloadimgallAPI({
        imgList: imgList
      }).then(res => {
        if (res?.status === 200 && res?.data?.status === 1) {
          // 创建一个临时的a标签用于下载
          const a = document.createElement('a');
          a.href = `${window.location.protocol}${res.data.data}`;
          a.download = 'images.zip'; // 设置下载文件名
          document.body.appendChild(a);
          a.click();
          // 清理
          document.body.removeChild(a);
        }
      });
      base64List.map(async (i, index) => {
        await this.savaBase64AsPng(i).then(data => {
          const time = new Date().getTime();
          if (that.zip && that.zip.file) {
            that.zip.file(`${time}_base64.png`, data, {
              binary: true
            });
            if (index === base64List.length - 1) {
              this.zip.generateAsync({
                type: 'blob'
              }).then(data => {
                const url = URL.createObjectURL(data);
                // 创建一个临时的a标签用于下载
                const a = document.createElement('a');
                a.href = url;
                a.download = `base64aspng.zip`; // 设置下载文件名
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                this.promises = [];
                setTimeout(() => {
                  this.zip = null;
                }, 1000);
              });
            }
          }
        }).catch(err => {
          console.log(err, 'err=======----------');
        });
      });
    },
    clearFileList() {
      this.fileList = [];
      this.showClear = false;
    }
  }
};